let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cGVHa")).then(() => parcelRequire('7ApBu'));